module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-radiogroup weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.show) ? _c('dof-mask', {
    attrs: {
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.layoutClick($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    ref: "radiogroupBox",
    staticClass: "dof-radiogroup-box weex-ct weex-div",
    style: ({
      bottom: _vm._px2rem('-' + _vm.height + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('scroller', {
    staticClass: "dof-radiogroup-content",
    style: ({
      height: _vm._px2rem(_vm.height - 28 + 'px', 75)
    }),
    attrs: {
      "show-scrollbar": "false"
    }
  }, [_c('div', {
    staticClass: "dof-radiogroup-item-wrapper weex-ct weex-div",
    style: ({
      'min-height': _vm.height - 28 + 'px'
    }),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.items), function(item, i) {
    return _c('div', {
      key: i,
      ref: 'item' + i,
      refInFor: true,
      staticClass: "dof-radiogroup-item weex-ct weex-div",
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.radiogroupItemClick(item, i, item[_vm.keyField])
        }
      }
    }, [_c('div', {
      staticClass: "icon-wrapper weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [(_vm.index == i && _vm.isShowIcon) ? _c('figure', {
      staticClass: "item-icon weex-el weex-image",
      attrs: {
        "src": _vm.radioIcon,
        "data-img-src": _vm.radioIcon,
        "weex-type": "image"
      }
    }) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "item-text weex-el weex-text",
      style: ({
        color: _vm.color(item, i)
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(_vm.display(item)))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dof-radiogroup-bottom weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('p', {
    staticClass: "btn-grp-text btn-cancel weex-el weex-text",
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.cancelClick($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('p', {
    staticClass: "btn-grp-text btn-confirm weex-el weex-text",
    attrs: {
      "weex-type": "text",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.confirmClick($event)
      }
    }
  }, [_vm._v("确定")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68331f12", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68331f12","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-select/index.vue
// module id = 622
// module chunks = 0 1